import {number, oneOf, shape, string, bool, arrayOf, func } from 'prop-types';

export const paginationType = shape({
	totalElements: number,
	totalPages: number,
	size: number,
	currentPage: number
});


export const colorTypes = oneOf(
	[
		'mred',
		'red',
		'pink',
		'purple',
		'deep-purple',
		'indigo',
		'blue',
		'blight',
		'cyan',
		'teal',
		'green',
		'light-green',
		'lime',
		'yellow',
		'amber',
		'orange',
		'deep-orange',
		'brown',
		'blue-grey',
		'grey'
	].flatMap(c => [c, `light ${c}`, `dark ${c}`])
);

export const jobsInstanceType = shape({
	startTime: string,
	endTime: string,
});

export const jobsStateType = shape({
	isLoading: shape({
		jobAction: bool,
		jobs: bool,
	}),
	errors: shape({}),
	data: shape({
		jobs: arrayOf(jobsInstanceType).isRequired,
	}),
	actions: shape({
		getJob: func.isRequired,
		startJob: func.isRequired,
		pauseJob: func.isRequired,
	}),
});
